import { HTTP } from "@/utils/http-common"

export default {
  get($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/back-office/products/${id}/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  transfer($, product_id, brand_id)  {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/back-office/products/${product_id}/transfer/`, {new_brand_id: brand_id})
        .then(response => resolve(response.data))
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
          
        })
    })
  },
  validate($, product_id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/back-office/products/${product_id}/validate/`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
          
        })
    })
  },
  bulkValidate($, product_ids) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/back-office/products/bulk-validate/`, { product_ids })
        .then(response => resolve(response.data))
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  bulkApprove($, product_ids) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/perfumist/back-office/products/bulk-approve/`, { product_ids })
        .then(response => resolve(response.data))
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  create($, product, id = null) {
    return new Promise((resolve, reject) => {
      let url = ""
      if (id) url = "/perfumist/back-office/products/" + id + "/new-request/"
      else url = "/perfumist/back-office/products/create-request/"
      HTTP.post(url, product)
        .then(response => {
          // $.$store.commit("success", "New entry created")
          resolve(response)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  cancel($, id) {
    return new Promise((resolve, reject) => {
      HTTP.post("/perfumist/back-office/products/" + id + "/cancel-request/")
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("error", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  editRequest: {
    approve($, product_id, proposal) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          `/perfumist/back-office/products/${product_id}/approve-request/`,
          {
            data_approved: proposal.data_approved
          }
        )
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    },
    update($, product_id, proposal) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          `/perfumist/back-office/products/${product_id}/update-request/`,
          {
            data_approved: proposal.data_approved
          }
        )
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    },
    reject($, product_id, msg) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          `/perfumist/back-office/products/${product_id}/reject-request/`,
          {
            message: msg
          }
        )
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    }
  },
  bulkDiscontinuate($, products) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `/perfumist/back-office/products/bulk-discontinuation/`,
        {
          products: products
        }
      )
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}